// src/app/enrollment-form.routes.ts
import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { ENROLLMENT_SHARED_USER_TYPES } from './core/constants/shared.access';

export const enrollmentFormRoute: Routes = [
    {
        path: 'enrollment-form',
        canActivate: [AuthGuard],
        data: { userTypes: ENROLLMENT_SHARED_USER_TYPES },
        loadComponent: () =>
            import('./student-dashboard/enrollment/enrollment-form/enrollment-form.component').then(
                m => m.EnrollmentFormComponent
            ),
    }
];